import { Checkbox } from '@mui/material';
import { HeaderCellProps } from '../types';

export const MembersV2CheckboxHeaderCell = ({ _customRowProps }: HeaderCellProps) => {
  const { allOnPageSelected, isIndeterminateOnPage, onToggleSelectAll } = _customRowProps;

  return (
    <Checkbox
      checked={allOnPageSelected}
      indeterminate={isIndeterminateOnPage}
      onChange={(e) => onToggleSelectAll((e.target as HTMLInputElement).checked)}
      slotProps={{
        input: { 'aria-label': 'select all' },
      }}
    />
  );
};

export default MembersV2CheckboxHeaderCell;
